import {
    USERS_FETCHING,
    USERS_FETCHING_SUCCESS,
    USERS_FETCHING_FAILURE,
} from '../actions/types'


const INITIAL_STATE = {
    fetching: false,
    items: [],
}

const reducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case USERS_FETCHING:
            return {
                ...state,
                fetching: true,
            }

        case USERS_FETCHING_SUCCESS:
            return {
                ...state,
                fetching: false,
                items: prepareItems(action.payload)
            }

        case USERS_FETCHING_FAILURE:
            return {
                ...state,
                fetching: false,
            }

        default:
            return state
    }
}

const prepareItems = data => {
    return data
}

export default reducer
